import "./es.object.assign-7e79fd7b.js";
import "./es.object.keys-9d66766f.js";
import { AnalyticsContext as p } from "@ucl/shared-component-foundations";
import { useContext as y, useRef as v, useEffect as l, useCallback as x } from "react";
import { usePopoverIndex as F } from "./usePopoverIndex.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
var R = function(e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var a = y(p), t = a.onAnalyticsEvent, n = v(t);
  l(function() {
    n.current = t;
  }, [t]);
  var u = v({
    staticData: e,
    dynamicData: r
  });
  return l(function() {
    u.current = {
      staticData: e,
      dynamicData: r
    };
  }, [e, r]), x(function(s, c) {
    var o;
    c === void 0 && (c = {});
    var i = u.current, f = i.staticData, m = i.dynamicData;
    !n.current || Object.keys(f).length === 0 || n.current(s.eventName, Object.assign((o = {}, o[s.dataElement] = Object.assign({}, c, f), o), m));
  }, []);
};
export {
  R as useFCAnalytics,
  F as usePopoverIndex
};
